import { Button } from '@mui/material';
import TextIncreaseIcon from '@mui/icons-material/TextIncrease';
import TextDecreaseIcon from '@mui/icons-material/TextDecrease';
import { useTextSize } from '../lib/textSize';
import { t } from '../i18n/sq';

/** Visible, labelled button (not just an icon) so it is easy to find. */
export function TextSizeToggle({ compact = false }: { compact?: boolean }) {
  const { large, toggle } = useTextSize();
  const label = large ? t.display.normalText : t.display.largerText;
  return (
    <Button
      onClick={toggle}
      color="inherit"
      aria-pressed={large}
      startIcon={large ? <TextDecreaseIcon /> : <TextIncreaseIcon />}
      sx={{
        whiteSpace: 'nowrap',
        ...(compact && { minWidth: 0, '& .MuiButton-startIcon': { m: 0 } }),
      }}
      aria-label={label}
      title={label}
    >
      {!compact && label}
    </Button>
  );
}
